import { getDistribution } from "./index244.js";
import { rootMeanSquareDifference } from "./index243.js";
function getUnitMixCost(state, props) {
  const distribution = getDistribution(state.sequence, props);
  const distributionCost = rootMeanSquareDifference(distribution, props.targetUnitMix.map((m) => m.ratio));
  return distributionCost;
}
export {
  getUnitMixCost
};
//# sourceMappingURL=index208.js.map
